export default __webpack_public_path__ + "static/media/time-series.92075cd8.webp";